import type { LngLat } from '../core/types';
import type { TrafficMode } from '../core/settings';

/**
 * Greater Bangkok, including the usual motorway approaches through Nonthaburi,
 * Pathum Thani and Samut Prakan. Mapbox selects one profile for the whole
 * request, so a journey that crosses this box uses traffic for the full route.
 */
const BANGKOK = {
  west: 100.28,
  east: 100.96,
  south: 13.42,
  north: 14.18,
};

export function insideBangkok([lng, lat]: LngLat): boolean {
  return (
    lng >= BANGKOK.west &&
    lng <= BANGKOK.east &&
    lat >= BANGKOK.south &&
    lat <= BANGKOK.north
  );
}

/** Liang-Barsky segment/rectangle intersection. */
function crossesBangkok(a: LngLat, b: LngLat): boolean {
  if (insideBangkok(a) || insideBangkok(b)) return true;
  const dx = b[0] - a[0];
  const dy = b[1] - a[1];
  const p = [-dx, dx, -dy, dy];
  const q = [
    a[0] - BANGKOK.west,
    BANGKOK.east - a[0],
    a[1] - BANGKOK.south,
    BANGKOK.north - a[1],
  ];
  let enter = 0;
  let leave = 1;
  for (let i = 0; i < 4; i++) {
    if (p[i] === 0) {
      if (q[i] < 0) return false;
      continue;
    }
    const r = q[i] / p[i];
    if (p[i] < 0) enter = Math.max(enter, r);
    else leave = Math.min(leave, r);
    if (enter > leave) return false;
  }
  return true;
}

export function shouldUseTraffic(mode: TrafficMode, origin: LngLat, destination: LngLat): boolean {
  if (mode === 'all') return true;
  if (mode === 'off') return false;
  return crossesBangkok(origin, destination);
}
